import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardBody, Col, Container, Row, Button } from 'reactstrap'
import PageTitle from '../../Components/Common/PageTitle'
import { DocumentForm, DocumentTable } from '../../Components/Documents'

const DocumentList = () => {
    const { t } = useTranslation()
    const [isDocumentFormOpen, setIsDocumentFormOpen] = useState(false)

    return (
        <div className="page-content">
            <Container fluid>
                <PageTitle title={t('app.common.documents')} />
                <Row>
                    {isDocumentFormOpen && (
                        <Col sm={12} xxl={3}>
                            <Card>
                                <div className="d-flex justify-content-between align-items-center w-100 p-3">
                                    <h5 className="fw-light m-0">{t('form.documentFormAdd.title.add')}</h5>
                                    <Button
                                        type="button"
                                        className="btn btn-dark btn-icon btn-sm fs-16 close-btn-overview"
                                        data-testid="document-add-close-btn"
                                        onClick={() => setIsDocumentFormOpen(false)}
                                    >
                                        <i className="mdi mdi-close align-bottom"></i>
                                    </Button>
                                </div>
                                <hr className="border-dashed mx-3 my-0" />
                                <CardBody>
                                    <DocumentForm mode="create" />
                                </CardBody>
                            </Card>
                        </Col>
                    )}
                    <Col sm={12} xxl={isDocumentFormOpen ? 9 : 12}>
                        <Card id="RealEstatesList">
                            <CardBody>
                                <DocumentTable onAddClick={isDocumentFormOpen ? undefined : () => setIsDocumentFormOpen(true)} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default DocumentList
